import React, {Component} from "react";
import {
    Button,
    FormField,
    FormSection,
    Input,
    InputLabel,
    Link,
    SectionBody,
    SectionFooter,
    SectionFooterPrimaryContent,
    SectionFooterSecondaryContent,
    SectionHeader
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {I18n} from "aws-amplify";
import {STYLE_LINK} from "../Styles/style";
import * as PropTypes from "prop-types";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import '../Styles/genelife.css';
import '../Styles/subpages.css';

export class ChangeEmailComponents extends Component {
    render() {
        return (
            <div>
            <Header/>
            <FormSection theme={this.props.theme}>
            <SectionHeader theme={this.props.theme}>{I18n.get("メールアドレス変更")}</SectionHeader>
            <SectionBody theme={this.props.theme}>
                <FormField theme={this.props.theme}>
                    <InputLabel theme={this.props.theme}>{I18n.get("メールアドレス")} *</InputLabel>
                    <Input
                        placeholder={I18n.get(" 新しいメールアドレスを入力してください")}
                        theme={this.props.theme}
                        key="email"
                        name="email"
                        onChange={this.props.handleInputChangeCustom}
                    />
                    {this.props.email_err_msg}
                </FormField>
                <FormField theme={this.props.theme}>
                    <InputLabel theme={this.props.theme}>{I18n.get("確認用メールアドレス")} *</InputLabel>
                    <Input
                        placeholder={I18n.get(" 上記と同じメールアドレスを入力してください")}
                        theme={this.props.theme}
                        key="email_confirm"
                        name="email_confirm"
                        onChange={this.props.handleInputChangeCustom}
                    />
                    {this.props.email_confirm_err_msg}
                </FormField>
            </SectionBody>
            <SectionFooter theme={this.props.theme}>
                <SectionFooterPrimaryContent theme={this.props.theme}>
                    <Button onClick={this.props.updateEmail} theme={this.props.theme}>
                        {I18n.get("変更する")}
                    </Button>
                </SectionFooterPrimaryContent>
                <SectionFooterSecondaryContent theme={this.props.theme}>
                    <Link theme={this.props.theme} style={STYLE_LINK} onClick={this.props.history_back}>
                        {I18n.get("前の画面へ戻る")}
                    </Link>
                </SectionFooterSecondaryContent>
            </SectionFooter>
        </FormSection>
        <Footer theme={this.props.theme}/>
        </div>);
    }
}

ChangeEmailComponents.propTypes = {
    theme: PropTypes.any,
    handleInputChangeCustom: PropTypes.func,
    email_err_msg: PropTypes.any,
    email_confirm_err_msg: PropTypes.any,
    updateEmail: PropTypes.func,
    history_back: PropTypes.func
};
